import React from 'react';
import { FormikProps } from 'formik';
import { SectionTitle } from '@/components/ui/section-title';
import { ActionButton, Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { FormikInput } from '@/components/ui/input';
import { TelefoneContatoDTO } from '@/types/TelefoneContatoDTO';
import { CheckIcon, PencilIcon, TrashIcon, Plus, Phone } from 'lucide-react';
import { Segurado } from '@/types/Segurado';

type SeguradoTelefoneSectionParams = {
    formikProps: FormikProps<Segurado>;
    novoContatoTelefone: () => void;
    salvarContatoTelefone: () => void;
    alterarContatoTelefone: (index: number) => void;
    removerContatoTelefone: (index: number) => void;
    loading: boolean;
    indexTelefoneEditando: number|undefined;
}

const SeguradoTelefoneSection: React.FC<SeguradoTelefoneSectionParams> = ({
    novoContatoTelefone, alterarContatoTelefone, removerContatoTelefone, salvarContatoTelefone, formikProps, loading, indexTelefoneEditando
}) => {
    return (
        <>
            <SectionTitle hasButton icon={<Phone />} cor="bg-sky-500/10 text-sky-600 dark:text-sky-400">
                Telefones
                <Button type="button" variant="outline" size="sm" className="disabled:hidden" onClick={novoContatoTelefone}><Plus className="mr-1.5 h-4 w-4" /> Adicionar</Button>
            </SectionTitle>
            {formikProps.values.telefones!?.length > 0 && (                                
                <Card className='w-full overflow-hidden shadow-none'>
                    <Table className="tabela-empilhada">
                        <TableHeader>
                            <TableRow>
                                <TableHead>Descrição</TableHead>
                                <TableHead>Telefone/Celular</TableHead>
                                <TableHead></TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {formikProps.values.telefones!.map((item, index) => (
                                <TableRow key={`telefone-${index}`}>
                                    <TableCell data-label="Descrição">
                                        {indexTelefoneEditando===index ? (
                                            <FormikInput showError={false} name={`telefones.${index}.descricao`} value={formikProps.values.telefones![index].descricao} />
                                        ): (
                                            <>                                        
                                                {item.descricao}
                                                {formikProps.errors.telefones && formikProps.errors.telefones[index] && (formikProps.errors.telefones[index] as unknown as TelefoneContatoDTO).descricao &&(
                                                    <div className='mt-1 text-xs font-medium text-destructive'>{`${(formikProps.errors.telefones[index] as unknown as TelefoneContatoDTO).descricao}`}</div>
                                                )}                                                                
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell data-label="Telefone/Celular">
                                        {indexTelefoneEditando===index ? (
                                            <FormikInput showError={false} name={`telefones.${index}.telefone`} value={formikProps.values.telefones![index].telefone}/>
                                        ): (
                                            <>
                                                {item.telefone}
                                                {formikProps.errors.telefones && formikProps.errors.telefones[index] && (formikProps.errors.telefones[index] as unknown as TelefoneContatoDTO).telefone &&(
                                                    <div className='mt-1 text-xs font-medium text-destructive'>{`${(formikProps.errors.telefones[index] as unknown as TelefoneContatoDTO).telefone}`}</div>
                                                )}                                                                
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell className='text-right'>
                                        {index === indexTelefoneEditando ? (
                                            <>
                                            <ActionButton icon={<CheckIcon className="h-3.5 w-3.5" />} label='Salvar Telefone' onClick={() => salvarContatoTelefone()} />
                                            </>
                                        ) : (
                                            <>
                                            <ActionButton icon={<PencilIcon className="h-3.5 w-3.5" />} label='Editar' onClick={() => alterarContatoTelefone(index)} />
                                            <ActionButton variant='destructive' icon={<TrashIcon className="h-3.5 w-3.5" />} label='Remover' onClick={() => removerContatoTelefone(index)} />
                                            </>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Card>
            )}                              
        </>
    );
}

export default SeguradoTelefoneSection;